import { render, staticRenderFns } from "./RMALabel.vue?vue&type=template&id=6c77e0ee&"
import script from "./RMALabel.vue?vue&type=script&lang=js&"
export * from "./RMALabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports